export const RECURRING_BILLING_FREQUENCIES = {
  // Minutely cadences are only supported for AT portals.
  MINUTES: 'MINUTES',
  TWO_MINUTES: 'TWO_MINUTES',
  THREE_MINUTES: 'THREE_MINUTES',
  FOUR_MINUTES: 'FOUR_MINUTES',
  FIVE_MINUTES: 'FIVE_MINUTES',
  TEN_MINUTES: 'TEN_MINUTES',
  DAYS: 'DAYS',
  WEEKS: 'WEEKS',
  TWO_WEEKS: 'TWO_WEEKS',
  MONTHS: 'MONTHS',
  QUARTERS: 'QUARTERS',
  SIX_MONTHS: 'SIX_MONTHS',
  YEARS: 'YEARS',
  TWO_YEARS: 'TWO_YEARS',
  THREE_YEARS: 'THREE_YEARS'
};